import React from "react";

const DeleteParcelNotifier = ({ result, url }) => {

  setTimeout(() => {
    window.location.href = url;
  }, 5000);

  return (
    <div
      style={{ margin: "3em auto", fontWeight: "bold", textAlign: "center" }}
    >
      <h3 style={{}}>Successfully removed Parcel Notification.</h3>
      <p>Redirecting to GIS Mapping Application in 5 seconds.</p>
    </div>
  );
};

export default DeleteParcelNotifier;
